import adstore from "@/stores/modules/adstore";

const init = (): Promise<void[]> => {
   const adStoreInit = adstore.init();
   
   return Promise.all([adStoreInit]);
};

export default init;